














import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {ServisnaOperacija, StavkaDokumenta} from "@/services/BackendProxies";
import dataProxy from '@/services/data-proxy.service';
import {mixins} from "vue-class-component";
import TableEditorsMixin from "@/mixins/table-editors.mixin";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class StavkeRezervniDelovi extends mixins(TableEditorsMixin, ComponentBaseMixin) {
    @Prop() stavke!: StavkaDokumenta[];

    columns = [];
    options = {};

    created() {
        this.columns = [
            {field: 'rezervniDeo', title: this.$i18n.t('rezervniDeo')},
            {field: 'kolicina', title: this.$i18n.t('kolicina'), width: 100, align: 'right'},
            {field: 'utrosenaKolicina', title: this.$i18n.t('utroseno'), formatter: this.utrosenaKolicinaFormatter, width: 100}
        ];
    }

    @Emit() otvoriTrebovanje() {}

    utrosenaKolicinaFormatter(value, row) {
        return this.vueFormatter({
            template: `
                <input type="number" v-model="row.utrosenaKolicina" class="form-control text-right"
                       :class="{invalid: row.utrosenaKolicina === undefined || row.utrosenaKolicina > row.kolicina || row.utrosenaKolicina < 0}"/>
            `,
            data: { row },
        })
    }
}
